import { tsAddAnimal } from '../ValidSamplesState'
import { tsAnimal } from '../../../../Typescript/DB_Interface'

/**
 * Initialize the AddAnimal state shape from a collection of animals.
 * Each animal (by UAI) starts with a single empty sample entry so the UI renders an input.
 */
export function initAddAnimals(animals: Partial<tsAnimal>[]): tsAddAnimal {
  const addAnimals: Partial<tsAddAnimal> = {}
  animals.forEach((a) => {
    addAnimals[a.UAI!] = [{ sampleID: '' }]
  })
  return addAnimals as tsAddAnimal
}
